import { Box, Typography } from "@mui/material";
import DataContent from "../../../components/DataContent";
import { DataCodeEnum } from "../../../constants/enum";
import PageContentEditor from "../../../components/PageContentEditor";

const IndicatorsName = () => {
  return (
    <Box m={2}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          color="primary"
          variant="h5"
          sx={{
            fontWeight: "bold",
          }}
          gutterBottom
        >
          Numerology Indicators - Name
        </Typography>
      </Box>
      {/* <DataContent
        code={DataCodeEnum.NUMEROLOGY_INDICATORS_NAME}
        name="Numerology Indicators - Name"
        fields={[
          {
            code: "name",
            name: "Name",
          },
          {
            code: "description",
            name: "Description",
          },
        ]}
      /> */}
      <Box
        sx={{
          height: "calc(100vh - 80px)",
        }}
      >
        <PageContentEditor
          dataCode={DataCodeEnum.NUMEROLOGY_INDICATORS_NAME}
          dataName={"Numerology Indicators - Name"}
        />
      </Box>
    </Box>
  );
};

export default IndicatorsName;
